
import { IChartOptions, IChartResult } from './chartSteps';
import { isNil } from 'lodash';

import {
	axisesAndLegends,
	IAxisesAndLegendsResult,
	tryApplyCustomColors,
	tryPercentage,
	tryTranslateCaption
} from './chartSteps';
import { ApexOptions } from 'apexcharts';
import { ResultSet } from '@cubejs-client/core';
import { cloneDeep, merge } from 'lodash';

export default function pieDonutChart(resultSet: ResultSet, options: IChartOptions, isGroupedByWeek: boolean): IChartResult {
	// IChartProps - IChartOptions
	let r = axisesAndLegends(resultSet, cloneDeep(options), isGroupedByWeek);
	r = tryApplyCustomColors(r);
	r = tryPercentage(r);

	return toChartResult(r, options);
	// r = tryApplyCustomColors(r);
}

function toChartResult(result: IAxisesAndLegendsResult, options: IChartOptions): IChartResult {
	const isDonut = Array.isArray(result.input.options.config)
		? result.input.options.config[0].isDonut
		: result.input.options.config.isDonut;

	const defaultOptions: ApexOptions = {
		chart: {
			type: isDonut ? 'donut' : 'pie',
		},
		dataLabels: {
			formatter: function (val, opts) {
				let isPercentage = false;
				if (!isNil(result) && !isNil(result.input) && !isNil(result.input.options)
					&& !isNil(result.input.options.config))
					isPercentage = Array.isArray(result.input.options.config)
						? result.input.options.config[0].isPercentage
						: result.input.options.config.isPercentage;

				return isPercentage ? `${(val as any).toFixed(1)}%` : opts.w.config.series[opts.seriesIndex];
			},
		},
		legend: {
			formatter: seriesName => tryTranslateCaption(seriesName, options.translate),
			offsetY: 20
		},
		xaxis: {
			labels: {
				formatter: value => tryTranslateCaption(value, options.translate)
			}
		},
		tooltip: {
			y: {
				title: {
					formatter: val => tryTranslateCaption(val, options.translate)
				}
			}
		},
		labels: Object.keys(result.output.pivots.axisNames).map(x => result.output.pivots.axisNames[x].axisName)
	};
	const firstSerie = result.output.pivots.series.shift();
	const mergedSeries = isNil(firstSerie) ? [] : firstSerie.data;
	result.output.pivots.series.forEach((serie, index) => {
		mergedSeries[index+1] = serie.data[index+1];
	});
	return {
		options: merge({}, result.output.chartResult.options, defaultOptions),
		series: mergedSeries
	};
}
